export class SaleOrderLineComplement {
  constructor(
    public hash?: string,
    public complementHash?: string,
    public complementName?: string,
    public complementCode?: string,
    public complementDescription?: string,
    public complementNeedSerialNumber?: string,
    public complementWeight?: number,
    public amount?: number,
    public totalAmount?: number
  ) { }

  clone() {
    return new SaleOrderLineComplement(
      this.hash,
      this.complementHash,
      this.complementName,
      this.complementCode,
      this.complementDescription,
      this.complementNeedSerialNumber,
      this.complementWeight,
      this.amount,
      this.totalAmount
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-line-complement.ts